<div class="u-flex u-justify-between u-items-center u-mb-2">

    <div class="u-flex u-items-center">
  
      <div class="u-flex-grow-0 u-flex-shrink-0 u-w-18" 
      *ngIf="state.showSelectAll">
        <p-checkbox [(ngModel)]="state.selectAll" 
          class="u-flex u-justify-center u-h-100% u-mr-0"
          [binary]="true" 
          (onChange)="selectAllValues()">
        </p-checkbox>
      </div>
  
      <div class="u-flex u-items-center">
        <div *ngIf="state.showFilters && state.filters.options?.length > 0" class="u-col u-col-fixed u-self-end filters">
          <p-multiSelect class="u-mr-4"
              [options]="state.filters.options"
              [(ngModel)]="state.filters.selectedOptions"
              (onChange)="handleFilterSelection()"
              [defaultLabel]="state.filters.label"
              selectedItemsLabel="{0} filter(s) selected">
          </p-multiSelect>
        </div>
        <div *ngIf="state.showViewBy && state.viewBy?.length > 0">
          <p-dropdown
            [options]="state.viewBy" 
            [(ngModel)]="state.viewSelected" 
            (onChange)="handleViewSelection()"
            [scrollHeight]="'unset'"
            data-cy="content-toolbar-viewBy">
            <ng-template let-item pTemplate="selectedItem">
              <div class="u-flex u-items-center">
                <i *ngIf="item.icon?.name" 
                  class="material-icons c-icon-sm">{{ item.icon?.name }}</i>
                <i *ngIf="item.icon?.cssClasses"
                  class=" c-icon-sm {{item.icon?.cssClasses}}"></i>
                <span class="u-text-sm u-ml-2">{{item.label}}</span>
              </div>
            </ng-template>
            <ng-template let-view pTemplate="item">
              <div class="u-flex u-items-center" 
              data-cy="content-toolbar-viewBy-option">
                <i *ngIf="view.icon?.name" class="material-icons c-icon-sm">{{ view.icon?.name }}</i>
                <i *ngIf="view.icon?.cssClasses" class="c-icon-sm {{view.icon?.cssClasses}}"></i>
                <div class="u-text-sm u-ml-2">{{view.label}}</div>
              </div>
            </ng-template>
          </p-dropdown>
  
        </div>
  
        <p-dropdown *ngIf="state.showGroupBy && state.group.options?.length > 0"
          class="u-ml-4" 
          [options]="state.group.options"
          [(ngModel)]="state.group.selectedOption" 
          (onChange)="handleGroupSelection()"
          data-cy="content-toolbar-groupby"></p-dropdown>
  
          <p-dropdown *ngIf="state.showSortBy && state.sort.options?.length > 0"
            class="u-ml-4" 
            data-cy="content-toolbar-sort"
            [options]="state.sort.options" 
            [(ngModel)]="state.sort.selectedOption" 
            (onChange)="handleSortSelection()"
            data-cy="content-toolbar-sort">
          </p-dropdown>
  
          <i *ngIf="state.showSortBy"
            class="material-icons u-mx-4 u-my-0 u-cursor-pointer"
            (click)="sort()" 
            [pTooltip]="state.sort.order === 'asc' ?  'ascending' : 'descending'">
            swap_vert
          </i>
  
      </div>
  
    </div>
  
    <div *ngIf="state.showSearch">
      <al-search-bar #alSearchBar 
      [placeholder]="state.search.textPlaceHolder"
      [maxSearchLength]="state.search.maxSearchLength" 
      (onSearchChanged)="applyTextFilter($event)">
      </al-search-bar>
    </div>
  
  </div>
  